import { Controller, useForm } from "react-hook-form";
import { trackPromise } from "react-promise-tracker";
import { Button, TextField } from "@mui/material";
import apiClient from "../../lib/api";
import urlConstant from "../../constants/urlConstants";
import dataConstant from "../../constants/dataConstants";

const MarketerCodeVerify = ({ saveMarketerCode, setIsCodeValidPopupOpen }) => {
  const staticAuthorizationCode =
    process.env.REACT_APP_STATIC_AUTHORIZATIONCODE;
  const {
    handleSubmit,
    control,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
    },
  });

  const onSubmit = (data) => {
    trackPromise(
      apiClient
        .get(
          `${urlConstant.Submission.VerifyMarketerCode}?code=${data?.code}`,
          {
            authRequired: false,
            headers: {
              "X-AUTHORIZE-CODE": staticAuthorizationCode,
            },
          }
        )
        .then((response) => {
          if (response.status === dataConstant.APIStatus.Failure) {
            setError("code", { type: "manual", message: response?.message });
          } else {
            saveMarketerCode(data?.code);
            setIsCodeValidPopupOpen(false);
          }
        })
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Controller
        name="code"
        control={control}
        rules={{ required: "Password is required" }}
        render={({ field }) => (
          <TextField
            {...field}
            label="Password"
            variant="outlined"
            fullWidth
            margin="normal"
            sx={{ my: 0 }}
            error={!!errors.code}
            helperText={errors.code?.message}
          />
        )}
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ ml: "auto", display: "flex", mt: 4 }}
      >
        Verify
      </Button>
    </form>
  );
};
export default MarketerCodeVerify;
